import { getRgObjectsOfType as i, RG_TYPE as t } from "@project-rouge/rg-core";
import { getBuildingChildrenAtLevel as l } from "../../../utils/rg-util/index.js";
import { isBaseBuildObject as n } from "../../queries/index2.js";
import { isMiscDoor as g } from "../../queries/index6.js";
const B = (e, o) => {
  const r = i(e, t.Building), s = l(r, o).filter(n);
  return i(s, t.Door).filter(g).length;
};
export {
  B as getLevelBaseBuildMiscDoorsCount
};
//# sourceMappingURL=index6.js.map
